import { defineStore } from 'pinia'
import _ from 'lodash'

export const useProjectStore = defineStore('project', {
	state: () => {
		return {
			projects: [],
		}
	},
	getters: {
		ready: (state) => {
			return state.projects.length > 0 ?? false
		},
		categories: (state) => {
			let allCategories = state.projects?.flatMap(({ categories }) => categories).filter(Boolean)
			let categories = [...new Set(allCategories.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(categories, 'name', 'desc')
		},
		industries: (state) => {
			let allIndustries = state.projects?.flatMap(({ industries }) => industries).filter(Boolean)
			let industries = [...new Set(allIndustries.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(industries, 'name', 'desc')
		},
	},
	actions: {
		setup() {
			this.getProjects()
		},
		getProjects() {
			return axios
				.get('/api/project')
				.then((projects) => {
					this.projects = projects.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
